import {
  AudioOutlined,
  CloseOutlined,
  CommentOutlined,
  CopyOutlined,
  DownOutlined,
  EditOutlined,
  GlobalOutlined,
  MoreOutlined,
  PaperClipOutlined,
  SendOutlined,
  UserOutlined,
  SyncOutlined,
  CalendarOutlined,
  SearchOutlined,
  FileTextOutlined,
  FileDoneOutlined,
  MessageOutlined,
  WarningOutlined
} from "@ant-design/icons";

import { Avatar, Button, Dropdown, Tooltip } from "antd";
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import VitalsDialog from '../VitalModal/VitalModal';
import RegisterModal from '../registerModal/registerModal';

import SERVICE_BASE_URLS from "../../utils/apiConfig";
import { startChatTypewriter } from "../../utils/chatTypewriter";

import { Box, Grid, Paper, Typography } from '@mui/material';
import {
  DUMMY_IMAGING_REPORT,
  DUMMY_PRESCRIPTION_REPORT,
  DUMMY_VACCINATION_REPORT,
} from "../../data/chatbotDummyReports";
import { getEffectiveUserData } from "../../utils/activeProfileStorage";
import { getDeviceId } from "../../utils/deviceFingerprint";
import "./ChatBoatGuest.scss";

import { Activity, Droplets, Pill, Square, Thermometer, Wind } from 'lucide-react';
import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";

const ChatBoatGuest = () => {

  const [loginError, setLoginError] = useState(false);
  const [pcId, setPcId] = useState('');
  const [open, setOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [openSignUp, setopenSignUp] = useState(false);
  const [refresh, setRefresh] = useState(false)

  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState(null);


  useEffect(() => {
    const fetchId = async () => {
      const id = await getDeviceId();
      setPcId(id);
      console.log("Unique Device ID for this PC:", id);
    };
    fetchId();
  }, []);


  const handleVital = (key) => {
    const item = vitalsLogs.find((v) => v.key === key);
    if (item) {
      setSelectedItem(item);
      setOpen(true);
    }
  };
  const messageStyle = {
    fontFamily: 'Arial, sans-serif',
    fontSize: '16px',
    fontWeight: '500',
    color: '#000',
    lineHeight: 1.5,
    padding: '2%',
    cursor: 'pointer',
    border: '1px solid #8080806b'
  };
  const messageStyle1 = {
    fontFamily: 'Arial, sans-serif',
    fontSize: '16px',
    fontWeight: '500',
    color: '#ffff',
    lineHeight: 1.5,
    padding: '1.5%',
    cursor: 'default',
  };
  const messageStyle2 = {
    fontFamily: 'Arial, sans-serif',
    fontSize: '16px',
    fontWeight: '500',
    color: '#000',
    lineHeight: 1.5,
    padding: '1% 4% 1% 4%',
    cursor: 'pointer',
    border: '1px solid #8080806b'
  };



  const handleCloseSignup = () => {
    setopenSignUp(false);
    setSelectedItem(null);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedItem(null);
  };
  const [userData, setUserData] = useState(() => getEffectiveUserData());
  useEffect(() => {
    const sync = () => setUserData(getEffectiveUserData());
    window.addEventListener("activeProfileChanged", sync);
    return () => window.removeEventListener("activeProfileChanged", sync);
  }, []);
  const userId = userData?.userId;

  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);

  const [selectedFile, setSelectedFile] = useState(null);
  const [showMemberSelect, setShowMemberSelect] = useState(false);
  const [showReportLanguage, setShowReportLanguage] = useState(false);
  const chatBodyRef = useRef(null);
  const fileInputRef = useRef(null);
  const chatInputRef = useRef(null);

  const CHAT_INPUT_MAX_HEIGHT_PX = 168;

  const adjustChatInputHeight = useCallback(() => {
    const el = chatInputRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, CHAT_INPUT_MAX_HEIGHT_PX)}px`;
  }, []);

  const abortControllerRef = useRef(null);
  const typewriterControlRef = useRef(null);

  const [chatBusy, setChatBusy] = useState(false);
  const [chatPhase, setChatPhase] = useState("idle");
  const [editingUserIndex, setEditingUserIndex] = useState(null);
  const [editDraft, setEditDraft] = useState("");
  const [id, setId] = useState("");
  const newMsgId = () =>
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random()}`;

  const stopChat = () => {
    if (typewriterControlRef.current) {
      typewriterControlRef.current.cancel();
      typewriterControlRef.current = null;
    }
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
    setChatPhase("idle");
    setChatBusy(false);
  };

  const copyUserMessageText = async (t) => {
    try {
      await navigator.clipboard.writeText(t ?? "");
      toast.success("Copied");
    } catch {
      toast.error("Could not copy");
    }
  };

  // Allow typing while fetching/typing; only block actions (send/edit/options) when busy.
  const actionsDisabled = chatBusy || disabled;
  const showChatStop = chatBusy;

  const [selectedLang, setSelectedLang] = useState("en");
  const [isRecording, setIsRecording] = useState(false);

  const handleVoiceCommand = () => {
    // Check if browser supports speech recognition
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      toast.error("Your browser does not support voice input.");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = 'en-US'; // You can change this to 'pa-IN' for Punjabi support!

    recognition.onstart = () => {
      console.log("Microphone is now active");
      setIsRecording(true);
    };

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      console.log(transcript)
      handleSend(transcript)
      // setMessage(transcript);
      setIsRecording(false);
    };

    recognition.onerror = (event) => {
      setIsRecording(false);
      if (event.error === 'no-speech') {
        toast.error("No speech was detected. Please try again.");
        // Or set a state: setStatusMessage("We didn't hear anything!");
      }
    };

    recognition.onend = () => {
      console.log("Microphone has turned off");
      setIsRecording(false);
    };

    if (!isRecording) {
      recognition.start();
    } else {
      recognition.stop();
    }
  };

  const vitalsLogs = [
    { key: 'hr', title: 'Heart Rate', icon: <Activity />, bgColor: '#FFE5E5' },
    { key: 'bp', title: 'Blood Pressure', icon: <Droplets />, bgColor: '#E0F2FE' },
    { key: 'temp', title: 'Temperature', icon: <Thermometer />, bgColor: '#FEF3C7' },
    // { key: 'resp', title: 'Respiration', icon: <Wind />, bgColor: '#DCFCE7' },
    { key: 'med', title: 'Medicine', icon: <Pill />, bgColor: '#F3E8FF' },
  ];
  const handleSidebarOption = (type) => {
    switch (type) {
      case "family":
        handleSend("Show my family members");
        break;
      case "medication":
        handleSend("Show my medications");
        break;
      case "vitals":
        handleSend("Show my vital reports");
        break;
      case "appointments":
        handleSend("Show my appointments");
        break;
      case "reports":
        handleSend("Show my reports");
        break;
      case "summary":
        handleSend("Show my health summary");
        break;
      default:
        break;
    }
  };

  const members = [
    { id: 1, name: "Self" },
    { id: 2, name: "Father" },
    { id: 3, name: "Mother" },
    { id: 4, name: "Wife" },
    { id: 5, name: "Son" },
    { id: 6, name: "Daughter" },
  ];


  // useLayoutEffect(() => {
  //   const el = chatBodyRef.current;
  //   if (el) {
  //     const nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 80;
  //     if (nearBottom) el.scrollTop = el.scrollHeight;
  //   }
  // }, [messages]);
  useEffect(() => {
    chatBodyRef.current?.scrollTo({
      top: chatBodyRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [messages]);

  // When chat is open, lock page/body scroll so only chat scrolls.
  useEffect(() => {
    setId(newMsgId())
    if (!isOpen) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen]);

  useLayoutEffect(() => {
    adjustChatInputHeight();
  }, [message, isOpen, adjustChatInputHeight]);

  const handleConfirmVitals = (data) => {
    handleSend(`Logged ${data.title}: ${data.value}`)
    handleClose();
  };

  const handleConfirmSignUp = (data) => {
    handleCloseSignup();
  };

  const formatMedicalReport = (data) => {
    if (!data || typeof data !== "object") {
      return <Typography color="error">Invalid report data received.</Typography>;
    }

    const fmtKey = (key) => key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    const renderVal = (val) => {
      if (val == null || val === "") return "N/A";
      if (Array.isArray(val)) return val.join(", ");
      return String(val);
    };

    return (
      <Paper elevation={3} sx={{
        p: 4, bgcolor: '#fff', maxWidth: '850px', margin: '20px auto',
        fontFamily: '"Inter", sans-serif', border: '1px solid #d1d5db', borderRadius: '4px',
        color: '#1e293b'
      }}>

        {/* --- 1. CLINIC & DOCTOR HEADER --- */}
        <Box sx={{ borderBottom: '2px solid #1a237e', pb: 2, mb: 3, display: 'flex', justifyContent: 'space-between' }}>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a237e' }}>
              🧾 {data.hospital_or_clinic || "MEDICAL REPORT"}
            </Typography>
            <Typography variant="body2" sx={{ color: '#475569', fontWeight: 600 }}>
              {data.document_category || "General"} {data.document_subtype ? `(${data.document_subtype})` : ""}
            </Typography>
            {data.body_part && (
              <Typography variant="body2" sx={{ mt: 1, color: '#1a237e', fontWeight: 700 }}>
                🫁 Body Part: {data.body_part}
              </Typography>
            )}
          </Box>
          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>Dr. {data.doctor_name || "N/A"}</Typography>
            <Typography variant="caption" sx={{ display: 'block' }}>{data.other?.doctor_qualifications || ""}</Typography>
            <Typography variant="caption" sx={{ display: 'block' }}>{data.other?.doctor_designation || ""}</Typography>
            <Typography variant="caption" sx={{ display: 'block', fontWeight: 700 }}>
              ID: {data.other?.doctor_registration_number || "N/A"}
            </Typography>
          </Box>
        </Box>

        {/* --- 2. PATIENT INFORMATION GRID --- */}
        <Grid container spacing={1} sx={{ mb: 4, p: 2, bgcolor: '#f8fafc', borderRadius: 1, border: '1px solid #e2e8f0', alignItems: 'flex-start' }}>

          {/* Gave more width to Name (3.5) */}
          <Grid item xs={3.5}>
            <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '0.72rem', display: 'flex', alignItems: 'center', gap: 0.5, color: '#1e293b' }}>
              👤 PATIENT NAME
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.3, pl: 2.5, fontWeight: 500, color: '#475569' }}>
              {data.patient_name || 'N/A'}
            </Typography>
          </Grid>

          {/* Age / Sex */}
          <Grid item xs={3}>
            <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '0.72rem', display: 'flex', alignItems: 'center', gap: 0.5, color: '#1e293b' }}>
              🎂 AGE / ⚧ SEX
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.3, pl: 2.5, whiteSpace: 'nowrap', color: '#475569' }}>
              {data.patient_age ? `${data.patient_age} / ` : ''}{data.patient_gender || 'N/A'}
            </Typography>
          </Grid>

          {/* Family Member */}
          <Grid item xs={2.5}>
            <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '0.72rem', display: 'flex', alignItems: 'center', gap: 0.5, color: '#1e293b' }}>
              👪 FAMILY
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.3, pl: 2.5, color: '#475569' }}>
              {data.family_member || 'Self'}
            </Typography>
          </Grid>

          {/* Hospital Address */}

        </Grid>

        <Box sx={{ mb: 4 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 800, borderBottom: '1px solid #e2e8f0', mb: 1, color: '#1a237e' }}>    🏥 HOSPITAL ADDRESS</Typography>
          <Grid item xs={3} sx={{ textAlign: 'left' }}>

            <Typography variant="body2" sx={{ mt: 0.3, color: '#475569' }}>
              {data.other?.hospital_address || 'N/A'}
            </Typography>
          </Grid>
        </Box>

        {/* --- 3. CLINICAL DETAILS --- */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 800, borderBottom: '1px solid #e2e8f0', mb: 1, color: '#1a237e' }}>📌 CLINICAL OBSERVATIONS</Typography>
          <Grid container spacing={1}>
            <Grid item xs={12}><Typography variant="body2"><strong>Complaints:</strong> {renderVal(data.other?.complaints)}</Typography></Grid>
            <Grid item xs={12}><Typography variant="body2"><strong>📋 Diagnosis:</strong> {renderVal(data.other?.diagnosis)}</Typography></Grid>
            <Grid item xs={12}><Typography variant="body2"><strong>🩺 Examination:</strong> {renderVal(data.other?.examination)}</Typography></Grid>
          </Grid>
        </Box>

        {/* --- 4. VITALS DASHBOARD --- */}
        {data.other?.vitals && (
          <Box sx={{ mb: 4 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1 }}>❤️ VITALS</Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, p: 2, border: '1px solid #e2e8f0', borderRadius: 2, bgcolor: '#fff' }}>
              {Object.entries(data.other.vitals).map(([key, val]) => (
                <Box key={key} sx={{ minWidth: '110px' }}>
                  <Typography variant="caption" color="textSecondary" sx={{ textTransform: 'uppercase', fontSize: '9px' }}>{fmtKey(key)}</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 700, color: '#dc2626' }}>{renderVal(val)}</Typography>
                </Box>
              ))}
            </Box>
          </Box>
        )}

        {/* --- 5. VACCINATION RECORD (If exists) --- */}
        {Array.isArray(data.vaccines) && data.vaccines.length > 0 && (
          <Box sx={{ mb: 4 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#1a237e', borderBottom: '1px solid #e2e8f0', mb: 1 }}>💉 VACCINATION RECORD</Typography>
            {data.vaccines.map((v, i) => (
              <Box key={i} sx={{ ml: 2, mb: 1 }}>
                <Typography variant="body2"><strong>{i + 1}. {v.vaccine_name}</strong> — Dose {v.dose_number} ({v.date_administered})</Typography>
                <Typography variant="caption" sx={{ ml: 2, display: 'block' }}>Administered By: {v.administered_by}</Typography>
              </Box>
            ))}
          </Box>
        )}

        {/* --- 6. MEDICATIONS (Detailed Rx Style) --- */}
        {Array.isArray(data.medications) && data.medications.length > 0 && (
          <Box sx={{ mb: 4 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#1a237e', borderBottom: '1px solid #e2e8f0', mb: 2 }}>💊 MEDICATIONS (Rx)</Typography>
            {data.medications.map((med, i) => (
              <Box key={i} sx={{ mb: 2, pb: 1, borderBottom: '1px dashed #cbd5e1' }}>
                <Typography variant="body1" sx={{ fontWeight: 700 }}>{i + 1}. {med.name} {med.is_supplement && <small>(Supplement)</small>}</Typography>
                <Grid container sx={{ mt: 0.5, pl: 2 }} spacing={1}>
                  <Grid item xs={12}><Typography variant="caption"><strong>Salt Composition:</strong> {renderVal(med.salt_composition)}</Typography></Grid>
                  <Grid item xs={3}><Typography variant="caption"><strong>Dosage:</strong> {renderVal(med.dosage)}</Typography></Grid>
                  <Grid item xs={3}><Typography variant="caption"><strong>Frequency:</strong> {renderVal(med.frequency)}</Typography></Grid>
                  <Grid item xs={3}><Typography variant="caption"><strong>Duration:</strong> {renderVal(med.duration)}</Typography></Grid>
                  <Grid item xs={12}><Typography variant="caption" sx={{ color: '#b91c1c' }}><strong>Side Effects:</strong> {renderVal(med.side_effects)}</Typography></Grid>
                  <Grid item xs={12}><Typography variant="caption" sx={{ fontStyle: 'italic', color: '#475569' }}><strong>Instructions:</strong> {renderVal(med.instructions)}</Typography></Grid>
                </Grid>
              </Box>
            ))}
          </Box>
        )}

        {/* --- 7. CATCH-ALL FOR "OTHER" DATA (Ensures nothing is missed) --- */}
        {data.other && (
          <Box sx={{ mb: 4 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#64748b', borderBottom: '1px solid #e2e8f0', mb: 1 }}>ADDITIONAL DETAILS</Typography>
            <Grid container spacing={1} sx={{ pl: 1 }}>
              {Object.entries(data.other).map(([key, value]) => {
                const excludedKeys = ["vitals", "investigations", "advice", "doctor_registration_number", "doctor_qualifications", "doctor_designation", "hospital_address", "complaints", "diagnosis", "examination", "next_appointment"];
                if (excludedKeys.includes(key) || typeof value === "object") return null;
                return (
                  <Grid item xs={6} key={key}>
                    <Typography variant="caption" sx={{ fontWeight: 700 }}>{fmtKey(key)}: </Typography>
                    <Typography variant="caption">{renderVal(value)}</Typography>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        )}

        {/* --- 8. INVESTIGATIONS & ADVICE --- */}
        <Grid container spacing={4}>
          <Grid item xs={6}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, borderBottom: '1px solid #e2e8f0', mb: 1 }}>🔬 INVESTIGATIONS ADVISED</Typography>
            {data.other?.investigations?.map((test, i) => (
              <Typography key={i} variant="body2" sx={{ fontSize: '13px' }}>• {test}</Typography>
            )) || <Typography variant="caption">None</Typography>}
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, borderBottom: '1px solid #e2e8f0', mb: 1 }}>📝 ADVICE & FOLLOW-UP</Typography>
            <Typography variant="body2" sx={{ fontSize: '13px' }}>{renderVal(data.other?.advice)}</Typography>
            {data.other?.next_appointment && (
              <Typography variant="body2" sx={{ mt: 1, fontWeight: 700, color: '#1a237e' }}>
                📅 Next Appointment: {data.other.next_appointment}
              </Typography>
            )}
          </Grid>
        </Grid>

        {/* --- 9. SUMMARY FOOTER --- */}
        {data.document_summary && (
          <Box sx={{ mt: 4, p: 2, bgcolor: '#fffbeb', border: '1px solid #fde68a', borderRadius: 1 }}>
            <Typography variant="caption" sx={{ fontWeight: 800, display: 'block', mb: 0.5, color: '#92400e' }}>📄 CASE SUMMARY</Typography>
            <Typography variant="caption" sx={{ lineHeight: 1.4, color: '#b45309' }}>{data.document_summary}</Typography>
          </Box>
        )}
      </Paper>
    );
  };
  const renderBotText = (text) => {
    if (!text) return null;

    const parseInline = (raw) => {
      const elements = [];
      let remaining = String(raw ?? "");

      while (remaining.length > 0) {
        const linkMatch = remaining.match(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/);
        const boldMatch = remaining.match(/\*\*([^*]+)\*\*/);

        if (linkMatch && (!boldMatch || linkMatch.index <= boldMatch.index)) {
          if (linkMatch.index > 0) elements.push(remaining.slice(0, linkMatch.index));
          elements.push(
            <a
              key={elements.length}
              href={linkMatch[2]}
              target="_blank"
              rel="noopener noreferrer"
              className="chat-link"
            >
              {linkMatch[1]}
            </a>
          );
          remaining = remaining.slice(linkMatch.index + linkMatch[0].length);
        } else if (boldMatch) {
          if (boldMatch.index > 0) elements.push(remaining.slice(0, boldMatch.index));
          elements.push(<strong key={elements.length}>{boldMatch[1]}</strong>);
          remaining = remaining.slice(boldMatch.index + boldMatch[0].length);
        } else {
          elements.push(remaining);
          break;
        }
      }

      return elements;
    };

    let normalized = String(text)
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n")
      .replace(/\s*---+\s*/g, "\n\n---\n\n")
      .replace(/\n{3,}/g, "\n\n")
      .replace(
        /([.!?])(\s+)(?=[A-Z][A-Z\s]{2,}\s-\s)/g,
        (_, p, sp) => `${p}${sp}\n\n`
      );

    const lines = normalized.split("\n");
    const out = [];

    let i = 0;
    while (i < lines.length) {
      const line = lines[i];
      const trimmed = line.trim();

      if (trimmed === "---") {
        out.push(<hr key={`hr-${i}`} className="chat-hr" />);
        i += 1;
        continue;
      }

      const isBulletLine =
        trimmed.startsWith("- ") || trimmed.startsWith("* ") || trimmed.startsWith("• ");
      if (isBulletLine) {
        const items = [];
        while (i < lines.length) {
          const t = lines[i].trim();
          const isBullet =
            t.startsWith("- ") || t.startsWith("* ") || t.startsWith("• ");
          if (!isBullet) break;
          items.push(t.slice(2));
          i += 1;
        }
        out.push(
          <ul key={`ul-${i}`} className="chat-bullets">
            {items.map((t, idx) => (
              <li key={idx}>{parseInline(t)}</li>
            ))}
          </ul>
        );
        continue;
      }

      if (trimmed.length === 0) {
        out.push(<br key={`br-${i}`} />);
        i += 1;
        continue;
      }

      const disclaimerProbe = trimmed
        .replace(/^\*\*/g, "")
        .replace(/\*\*$/g, "")
        .trim();
      const isDisclaimer = /^disclaimer\s*[:\-]/i.test(disclaimerProbe) || /^disclaimer\b/i.test(disclaimerProbe);
      out.push(
        <div key={`p-${i}`} className={isDisclaimer ? "chat-disclaimer" : undefined}>
          {isDisclaimer ? <span className="chat-disclaimer-icon">⚠️</span> : null}
          <span>{parseInline(line)}</span>
        </div>
      );
      i += 1;
    }

    return out;
  };
  const sendChatRequest = async (trimmed) => {
    const obj = {
      device_id: pcId,
      session_id: id,
      user_id: userId?.toString?.() ?? "",
      message: trimmed,
      language: selectedLang || "en",
      refresh: refresh,
    };

    const base = SERVICE_BASE_URLS.dsApis || "";
    const url = `${base.endsWith("/") ? base.slice(0, -1) : base}/chat`;

    const ac = new AbortController();
    abortControllerRef.current = ac;
    setChatPhase("fetching");
    setChatBusy(true);

    try {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      const headers = { "Content-Type": "application/json" };
      if (token) headers.Authorization = `Bearer ${token}`;

      const res = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(obj),
        signal: ac.signal,
      });

      if (!res.ok) {
        if (res.status === 429) {
          setLoginError(true);
          setTimeout(() => setLoginError(false), 2000);
          setopenSignUp(true);
          setChatPhase("idle");
          setChatBusy(false);
          abortControllerRef.current = null;
          return;
        }
        throw new Error(`chat ${res.status}`);
      }

      const response = await res.json();
      const { intent, response: botText, sources, question_options, severity } = response;

      if (["INFORMATION", "FOLLOW_UP", "CHITCHAT"].includes(intent)) {
        const meta = {
          sources: sources || [],
          question_options: question_options || [],
          severity: severity || {},
        };
        const full = botText ?? "Response received.";
        const botId = newMsgId();

        setChatPhase("typing");
        setMessages((prev) => [
          ...prev,
          {
            type: "bot",
            id: botId,
            text: "",
            streaming: true,
            ...meta,
          },
        ]);

        typewriterControlRef.current = startChatTypewriter({
          fullText: full,
          onTick: (slice) => {
            setMessages((prev) => {
              const i = prev.findIndex((m) => m.id === botId);
              if (i === -1) return prev;
              const u = [...prev];
              u[i] = { ...u[i], text: slice };
              return u;
            });
          },
          onComplete: () => {
            setMessages((prev) => {
              const i = prev.findIndex((m) => m.id === botId);
              if (i === -1) return prev;
              const u = [...prev];
              u[i] = { ...u[i], text: full, streaming: false };
              return u;
            });
            typewriterControlRef.current = null;
            abortControllerRef.current = null;
            setChatPhase("idle");
            setChatBusy(false);
          },
          onStoppedPartial: (partial) => {
            setMessages((prev) => {
              const i = prev.findIndex((m) => m.id === botId);
              if (i === -1) return prev;
              const u = [...prev];
              u[i] = {
                ...u[i],
                text: partial,
                streaming: false,
                streamStopped: true,
              };
              return u;
            });
            typewriterControlRef.current = null;
            abortControllerRef.current = null;
            setChatPhase("idle");
            setChatBusy(false);
            setMessage(partial);
            requestAnimationFrame(() => {
              const el = chatInputRef.current;
              el?.focus();
              if (el) {
                el.style.height = "auto";
                el.style.height = `${Math.min(
                  el.scrollHeight,
                  CHAT_INPUT_MAX_HEIGHT_PX
                )}px`;
              }
            });
          },
        });
      } else {
        setChatPhase("idle");
        setChatBusy(false);
        abortControllerRef.current = null;
      }
      setRefresh(false);
    } catch (error) {
      abortControllerRef.current = null;
      typewriterControlRef.current = null;
      const abortLike =
        error?.name === "AbortError" ||
        (typeof error?.error === "string" &&
          error.error.toLowerCase().includes("aborterror")) ||
        (typeof error?.data === "string" &&
          error.data.toLowerCase().includes("aborterror"));

      if (abortLike) {
        setChatPhase("idle");
        setChatBusy(false);
        return;
      }
      console.log(error);

      setMessages((prev) => [
        ...prev,
        {
          type: "bot",
          text: "Something went wrong. Please try again.",
        },
      ]);
      setChatPhase("idle");
      setChatBusy(false);
    }
  };
  const [member, setMember] = useState('')
  const submitEditUserMessage = async () => {
    if (editingUserIndex == null) return;
    const trimmed = editDraft.trim();
    if (!trimmed || actionsDisabled) return;
    stopChat();
    const idx = editingUserIndex;
    setEditingUserIndex(null);
    setEditDraft("");
    setMessages((prev) => [
      ...prev.slice(0, idx),
      { type: "user", text: trimmed, id: newMsgId() },
    ]);
    await sendChatRequest(trimmed);
  };

  const handleSend = async (text = message) => {
    if (!text?.trim() || actionsDisabled) return;

    const trimmed = text.trim();

    if (trimmed === "View Prescriptions") {
      setMessages((prev) => [
        ...prev,
        { type: "user", text: trimmed, id: newMsgId() },
        {
          type: "bot",
          text: (
            <>
              <div className="small text-muted mb-2">Sample prescription record (demo data)</div>
              {formatMedicalReport(DUMMY_PRESCRIPTION_REPORT)}
            </>
          ),
        },
      ]);
      setMessage("");
      return;
    }

    if (trimmed === "Lab Reports") {
      setMessages((prev) => [
        ...prev,
        { type: "user", text: trimmed, id: newMsgId() },
        {
          type: "bot",
          text: (
            <>
              <div className="small text-muted mb-2">
                Sample lab / imaging & immunization records (demo data)
              </div>
              {formatMedicalReport(DUMMY_VACCINATION_REPORT)}
              <div className="chat-report-divider my-3" />
              {formatMedicalReport(DUMMY_IMAGING_REPORT)}
            </>
          ),
        },
      ]);
      setMessage("");
      return;
    }

    setMessages((prev) => [...prev, { type: "user", text: trimmed, id: newMsgId() }]);
    setMessage("");

    await sendChatRequest(trimmed);
  };

  const handleComposeKeyDown = (e) => {
    if (e.key === "Escape") {
      e.currentTarget.blur();
      return;
    }
    if (e.key !== "Enter") return;
    if (e.shiftKey) return;
    e.preventDefault();
    if (actionsDisabled) return;
    handleSend();
  };

  const handleFileChange = (e) => {

    const file = e.target.files[0];

    if (!file || actionsDisabled) return;

    if (
      file.type !== "application/pdf" &&
      !file.type.startsWith("image/")
    ) {
      alert("Only PDF or Image files allowed");
      return;
    }

    setSelectedFile(file);

    setMessages((prev) => [
      ...prev,
      { type: "user", fileName: file.name },
      { type: "bot", text: "👨‍👩‍👧‍👦 Please select the family member for this report." },
    ]);

    setShowMemberSelect(true);

    e.target.value = null;
  };
  const handleMemberSelect = async (member) => {
    setMember(member.name)
    setMessages((prev) => [
      ...prev,
      { type: "user", text: member.name, id: newMsgId() },
      { type: "bot", text: " Please select the Language." },
    ]);

    setShowReportLanguage(true);
    setShowMemberSelect(false);
  };

  const handleMemberSelectLanguage = async (data) => {
    setMessages((prev) => [
      ...prev,
      { type: "user", text: data.label },
    ]);

    setShowReportLanguage(false);

    if (!selectedFile) return;

    let botMessageIndex;
    setMessages((prev) => {
      botMessageIndex = prev.length;
      return [
        ...prev,
        {
          type: "bot", text: (
            <>
              <span>Processing Document </span>
              <div className="spinner"></div>
            </>)
        },
      ];
    });

    try {
      setDisabled(true)
      const lang = languagesTranslate.filter((res) => res?.label == data?.label)
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("family_member", member.name);
      formData.append("patient_id", userId);
      formData.append("user_id", userId);
      formData.append("device_id", pcId);
      formData.append("session_id", id);
      formData.append("language", lang[0]?.code ? lang[0]?.code : '');


      const response = await fetch(
        process.env.REACT_APP_BASE_URL_DS2 + 'extract/document',
        {
          method: "POST",
          body: formData,
        }
      );
      setMember('')
      if (!response.ok) {
        if (response.status === 429) {

          setopenSignUp(true);
          toast.error("Shared trial limit reached (10 uses). Please log in to continue.")
          setLoginError(true);


          setTimeout(() => setLoginError(false), 2000);
          setMessages((prev) => prev.filter((_, i) => i !== botMessageIndex));
          return;
        }
        throw new Error(`Server Error: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");

      let buffer = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });

        const lines = buffer.split("\n");

        for (let line of lines) {
          line = line.trim();

          if (line.startsWith("data:")) {
            const jsonString = line.replace("data:", "").trim();
            if (!jsonString) continue;

            try {
              const data = JSON.parse(jsonString);

              setMessages((prev) => {
                const updated = [...prev];

                if (data.stage !== "done") {
                  // Update bot message with stage message + loader emoji
                  updated[botMessageIndex] = {
                    type: "bot",
                    text: (
                      <>
                        <span>{data.stage} </span>
                        <div className="spinner"></div> {/* Keep spinner on */}
                      </>
                    ),
                  };
                } else {
                  // Final formatted report — remove loader
                  const formattedReport = formatMedicalReport(data.data);

                  updated[botMessageIndex] = {
                    type: "bot",
                    text: formattedReport,  // no loader here
                  };
                  setDisabled(false)
                }

                //  setRefresh(false)

                return updated;
              });
            } catch (err) {
              console.error("JSON parse error:", err);
            }
          }
        }

        buffer = "";
      }
    } catch (error) {
      console.log(error)
      setDisabled(false)
      if (error?.status == 429) {
        // toast.error(error?.data)
        setopenSignUp(true)
        return
      }


      setMessages((prev) => {
        const updated = [...prev];
        updated[botMessageIndex] = {
          type: "bot",
          text: "Failed to process report. Please try again.",
        };
        return updated;
      });
    } finally {

    }


    setSelectedFile(null);
  };

  const translations = {
    en: [
      "Book Appointment",
      "Check Symptoms",
      "View Prescriptions",
      "Lab Reports",
      "Talk to Doctor",
      "Emergency Help"
    ],
    hi: [
      "अपॉइंटमेंट बुक करें",
      "लक्षणों की जांच करें",
      "नुस्खे देखें",
      "लैब रिपोर्ट",
      "डॉक्टर से बात करें",
      "आपातकालीन सहायता"
    ],
    ta: [
      "அப்பாயிண்ட்மெண்ட் முன்பதிவு",
      "அறிகுறிகளைச் சரிபார்க்கவும்",
      "மருந்துச் சீட்டுகளைப் பார்க்கவும்",
      "ஆய்வக அறிக்கைகள்",
      "மருத்துவரிடம் பேசுங்கள்",
      "அவசர உதவி"
    ],
    kn: [
      "ಅಪಾಯಿಂಟ್ಮೆಂಟ್ ಬುಕ್ ಮಾಡಿ",
      "ಲಕ್ಷಣಗಳನ್ನು ಪರೀಕ್ಷಿಸಿ",
      "ಪ್ರಿಸ್ಕ್ರಿಪ್ಷನ್ ವೀಕ್ಷಿಸಿ",
      "ಲ್ಯಾಬ್ ವರದಿಗಳು",
      "ವೈದ್ಯರೊಂದಿಗೆ ಮಾತನಾಡಿ",
      "ತುರ್ತು ಸಹಾಯ"
    ],
    pa: [
      "ਅਪੌਇੰਟਮੈਂਟ ਬੁੱਕ ਕਰੋ",
      "ਲੱਛਣਾਂ ਦੀ ਜਾਂਚ ਕਰੋ",
      "ਨੁਸਖ਼ੇ ਦੇਖੋ",
      "ਲੈਬ ਰਿਪੋਰਟਾਂ",
      "ਡਾਕਟਰ ਨਾਲ ਗੱਲ ਕਰੋ",
      "ਐਮਰਜੈਂਸੀ ਸਹਾਇਤਾ"
    ]
  };

  const items = [

    { label: "Settings", key: "settings" },
    { type: "divider" },
    { label: "Help", key: "help" },
  ];

  const languagesTranslate = [
    { code: "en", label: "English" },
    { code: "hi", label: "हिंदी" },
    { code: "ta", label: "தமிழ்" },
    { code: "kn", label: "ಕನ್ನಡ" },
    { code: "pa", label: "ਪੰਜਾਬੀ" },
  ];
  const itemsLanguage = languagesTranslate.map((lang) => ({
    key: lang.code,
    label: lang.label,
  }));

  const handleLanguageChange = ({ key }) => {
    setSelectedLang(key);
    console.log("Selected language:", key);
  };

  const selectedLabel =
    languagesTranslate.find((l) => l.code === selectedLang)?.label;


  const handleResetChat = () => {
    stopChat();
    setEditingUserIndex(null);
    setEditDraft("");
    setMessages([]);
    setRefresh(true)
    console.log("Chat has been reset for a new consultation");
  };

  const icons = [
    <CalendarOutlined />,
    <SearchOutlined />,
    <FileTextOutlined />,
    <FileDoneOutlined />,
    <MessageOutlined />,
    <WarningOutlined />
  ];
  return (
    <>
      {!isOpen && <div className="chatbot-launcher" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <CloseOutlined /> : <CommentOutlined />}
      </div>}
      {isOpen && (
        <div className="chat-popup">
          <div className="chat-header-custom1" style={{ padding: '20px  15px' }}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="d-flex align-items-center">
                  <div
                    className="bg-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: 45, height: 45, fontSize: 24, position: 'relative' }}
                  >
                    🩺
                    <div className="online-indicator"></div>
                  </div>
                  <div>
                    <div style={{ fontSize: '11px', opacity: 0.8 }}>Chat with</div>
                    <div className="fw-bold">Online Health Assistant</div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex gap-2">
                  <Dropdown
                    menu={{
                      items: itemsLanguage,
                      onClick: handleLanguageChange,
                    }}
                    trigger={["click"]}
                    placement="bottomRight"
                  >
                    <span style={{ cursor: "pointer", fontSize: "18px" }}>
                      <GlobalOutlined /> <span style={{ cursor: "pointer", fontSize: "14px" }}>{selectedLabel}</span>
                    </span>
                  </Dropdown>
                  <Button
                    type="text"
                    icon={<SyncOutlined />}
                    onClick={handleResetChat}
                    style={{ color: 'white', fontSize: '12px', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '20px' }}
                  >
                    New Chat
                  </Button>
                  <Dropdown menu={{ items }} trigger={["click"]} placement="bottomRight">
                    <MoreOutlined className="cursor-pointer" style={{ fontSize: 18 }} />
                  </Dropdown>
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <CloseOutlined
                    onClick={() => setIsOpen(false)}
                    className="cursor-pointer"
                    style={{ fontSize: 16, marginRight: '15px' }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <section className="card-content">
                <h4 className="mb-2">Quick Vitals Log</h4>
                <div className="row g-3 customize-card1 mt-2">
                  {/* <div className="col-12">
                    <div className="vitals-container-box" style={{ display: 'flex', justifyContent: 'space-around' }}>
                      {vitalsLogs.map((item, index) => (
                        <div className="vitals-quick-item text-center" key={index} onClick={() => handleVital(item.key)} title={item.desc || `${item.title}`} style={{
                          cursor: 'pointer',
                          marginLeft: index === 2 ? '-3%' : '0'
                        }}>
                          <div
                            className="icon-circle"
                            style={{ backgroundColor: item.bgColor, width: '60px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto' }}
                          >
                            {item.icon}
                          </div>
                          <span className="card-title d-block fw-bold" style={{ borderBlock: 'none' }}>{item.title}</span>
                        </div>
                      ))}
                    </div>
                  </div> */}
                  <div className="col-12">
                    {/* Use flex-wrap to allow items to move to the next line on small screens */}
                    <div
                      className="vitals-container-box d-flex flex-wrap justify-content-around align-items-center"
                      style={{ gap: '1rem' }}
                    >
                      {vitalsLogs.map((item, index) => (
                        <div
                          className="vitals-quick-item text-center"
                          key={index}
                          onClick={() => handleVital(item.key)}
                          title={item.desc || `${item.title}`}
                          style={{ cursor: 'pointer', flex: '1 1 80px', maxWidth: '120px' }}
                        >
                          <div
                            className="icon-circle mx-auto d-flex align-items-center justify-content-center"
                            style={{
                              backgroundColor: item.bgColor,
                              width: '60px',
                              height: '60px', // Changed to match width for a perfect circle
                              borderRadius: '50%'
                            }}
                          >
                            {item.icon}
                          </div>
                          <span className="card-title d-block fw-bold mt-2">
                            {item.title}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <RegisterModal
                  open={true}
                  handleClose={handleCloseSignup}
                  activeItem={selectedItem}
                  onConfirm={handleConfirmSignUp}
                  error={loginError}
                />
              </section>
            </div>
            <div className="col-md-8 main-container">
              <div className="chat-body-custom chat-window" ref={chatBodyRef}>
                {messages.length === 0 && (
                  <div className="mb-4">
                    <div className="bubble bot mb-2" style={{ border: '1px solid #8080806b' }}>👋 Welcome! How can I help?</div>
                  </div>
                )}
                {messages.map((msg, index) => (
                  <div key={msg.id ?? index} className={`msg-row ${msg.type === 'user' ? 'user' : 'bot'}`}>
                    {msg.type === 'user' && editingUserIndex === index ? (
                      <div className="user-message-edit-column">
                        <div className="user-message-edit-wrap">
                          <div
                            className="user-message-edit-card"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <textarea
                              className="user-message-edit-textarea"
                              value={editDraft}
                              onChange={(e) => setEditDraft(e.target.value)}
                              autoFocus
                              rows={4}
                              onKeyDown={(e) => {
                                if (e.key === "Escape") {
                                  setEditingUserIndex(null);
                                  setEditDraft("");
                                  return;
                                }
                                if (e.key === "Enter" && !e.shiftKey) {
                                  e.preventDefault();
                                  submitEditUserMessage();
                                }
                              }}
                            />
                            <div className="user-message-edit-actions">
                              <button
                                type="button"
                                className="user-message-edit-btn-cancel"
                                onClick={() => {
                                  setEditingUserIndex(null);
                                  setEditDraft("");
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="user-message-edit-btn-send"
                                onClick={submitEditUserMessage}
                              >
                                Send
                              </button>
                            </div>
                          </div>
                        </div>
                        {msg.fileName && (
                          <div className="mt-1 small user-message-edit-filenote">
                            📄 {msg.fileName}
                          </div>
                        )}
                      </div>
                    ) : msg.type === "user" ? (
                      <div className="user-message-with-actions">
                        {msg.text && (
                          <div
                            className="bubble user"
                            style={messageStyle1}
                          >
                            {msg.text}
                          </div>
                        )}
                        {!msg.fileName && (msg.text || "").length > 0 && (
                          <div className="user-message-actions">
                            <Tooltip title="Copy" color="#111" placement="bottom">
                              <button
                                type="button"
                                className="user-message-action-btn"
                                aria-label="Copy"
                                onClick={() => copyUserMessageText(msg.text)}
                              >
                                <CopyOutlined />
                              </button>
                            </Tooltip>
                            <Tooltip title="Edit message" color="#111" placement="bottom">
                              <button
                                type="button"
                                className="user-message-action-btn"
                                aria-label="Edit message"
                                disabled={actionsDisabled}
                                onClick={() => {
                                  if (actionsDisabled) return;
                                  setEditingUserIndex(index);
                                  setEditDraft(msg.text || "");
                                }}
                              >
                                <EditOutlined />
                              </button>
                            </Tooltip>
                          </div>
                        )}
                        {msg.fileName && (
                          <div
                            className="mt-1 bubble small opacity-75"
                            style={messageStyle1}
                          >
                            📄 {msg.fileName}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="bubble bot" style={messageStyle}>
                        {typeof msg.text === "string" ? (
                          <>
                            <div className="chat-bot-text-pre">
                              {renderBotText(msg.text)}
                            </div>
                            {msg.streaming ? (
                              <span className="chat-stream-cursor" aria-hidden>
                                ▍
                              </span>
                            ) : null}
                          </>
                        ) : (
                          msg.text
                        )}

                        {msg.fileName && (
                          <div className="mt-1 small opacity-75" style={messageStyle1}>
                            📄 {msg.fileName}
                          </div>
                        )}


                        {msg?.severity?.color_hex && !msg.streaming && (
                          <div
                            className="mt-1"
                            style={{
                              backgroundColor: msg.severity.color_hex,
                              width: '20px',
                              height: '20px',
                              borderRadius: '4px', // Use '50%' for a circle

                            }}
                            title={msg.severity.color_hex} // Shows the hex code on hover
                          />
                        )}
                        {msg.sources && msg.sources.length > 0 && !msg.streaming && (
                          <div className="chat-sources">
                            <div className="sources-container">
                              {msg.sources && msg.sources.length > 0 && (
                                <div className="chat-sources">
                                  <strong>Related topics:</strong>
                                  <div className="sources-container">
                                    {msg.sources.map((s, i) => (
                                      <a
                                        key={i}
                                        href={s.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="chat-chip chat-chip--source"
                                      >
                                        {s.title}
                                      </a>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        {msg.question_options && msg.question_options.length > 0 && !msg.streaming && (
                          <div className="chat-sources">
                            <div className="sources-container">
                              {msg.question_options && msg.question_options.length > 0 && (
                                <div className="" >
                                  <strong>Suggested questions:</strong>
                                  <div className="chat-options-grid">
                                    {msg.question_options.map((s, i) => (
                                      <button
                                        key={i}
                                        type="button"
                                        className="chat-chip chat-chip--option"
                                        onClick={() => handleSend(s)}
                                        disabled={actionsDisabled}
                                      >
                                        {s}
                                      </button>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ))}


                {showMemberSelect && (
                  <div className="quick-options-container mb-3">
                    {members.map((member) => (
                      <button key={member.id} className="option-pill" onClick={() => handleMemberSelect(member)}>
                        {member.name}
                      </button>
                    ))}
                  </div>
                )}
                {showReportLanguage && (
                  <div className="quick-options-container mb-3">
                    {languagesTranslate.map((member) => (
                      <button key={member.code} className="option-pill" onClick={() => handleMemberSelectLanguage(member)}>
                        {member.label}
                      </button>
                    ))}
                  </div>
                )}

                {chatPhase === "fetching" && (
                  <div className="msg-row bot" >
                    <div className="bubble bot" style={{ border: '1px solid #8080806b' }}>
                      <div className="loading-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="chat-footer-custom">
                <div className="quick-options-container">
                  {(translations[selectedLang] || translations.en).map((option, index) => (
                    <button
                      key={index}
                      className={`option-pill-default option-${index}`}
                      onClick={() => handleSend(option)}
                    >
                      <span className="icon">{icons[index]}</span>
                      <span>{option}</span>
                    </button>
                  ))}
                </div>
                <div className="input-wrapper">
                  <textarea
                    ref={chatInputRef}
                    className="chat-input"
                    placeholder="Send a message"
                    title="Enter — send · Shift+Enter — new line · Esc — blur"
                    rows={1}
                    value={message}
                    onChange={(e) => {
                      setMessage(e.target.value);
                      e.target.style.height = 'auto';
                      e.target.style.height = `${e.target.scrollHeight}px`;
                    }}
                    onKeyDown={handleComposeKeyDown}
                    disabled={disabled}
                  />

                  <div className="action-buttons">
                    <AudioOutlined
                      className={`audio-icon ${isRecording ? 'recording-active' : ''}`}
                      onClick={handleVoiceCommand}
                    />
                    <PaperClipOutlined
                      className="attachment-icon"
                      onClick={() => fileInputRef.current.click()}
                    />
                    <button
                      type="button"
                      className={`btn-send-float ${showChatStop || !actionsDisabled ? 'btn-send-float-active' : 'btn-send-float-inactive'}`}
                      onClick={() => (showChatStop ? stopChat() : handleSend())}
                      disabled={showChatStop ? false : actionsDisabled}
                      aria-label={showChatStop ? "Stop generating" : "Send message"}
                    >
                      {showChatStop ? (
                        <Square size={14} fill="currentColor" strokeWidth={0} />
                      ) : (
                        <SendOutlined />
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Hidden File Input */}
      <input
        type="file"
        accept="application/pdf,image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <VitalsDialog
        open={open}
        handleClose={handleClose}
        activeItem={selectedItem}
        onConfirm={handleConfirmVitals}
      />

    </>
  );
};

export default ChatBoatGuest;